export default __webpack_public_path__ + "static/beach-e7f152a2f3fd19533337c895d870b64c.jpg";